import React, { useMemo } from "react";
import './DiPch.css'
import DiSignal from "../../../UI/DiSignal/DiSignal";

export default function DiPch ({stateDi}) {
    const numberDi=['1', '2', '3', '4', '5','6'];
   
 // Преобразуем число в битовое представление и определяем состояние каждого DI
 const diStates = useMemo(() => {
    // Преобразуем в число, если пришла строка
    const numericStateDi = Number(stateDi);
    // Если преобразование не удалось или число не в диапазоне
    if (isNaN(numericStateDi) || numericStateDi < 0 || numericStateDi > 65535) {
        return numberDi.map(() => 'Off');
    }
    // Если число равно 0 или 65535, все DI выключены
    if (numericStateDi === 0 || numericStateDi === 65535) {
        return numberDi.map(() => 'Off');
    }
    
    // Преобразуем число в бинарную строку (16 бит)
    const binaryString = numericStateDi.toString(2).padStart(16, '0');
    
    // Для каждого DI проверяем соответствующий бит
    // Предполагаем, что DI1 соответствует младшему биту (бит 0)
    return numberDi.map((_, index) => {
        // Инвертируем индекс, так как биты обычно нумеруются справа налево
        const bitIndex = index; // DI1 = бит 0, DI2 = бит 1 и т.д.
        
        // Если индекс выходит за пределы 16 бит, возвращаем 'Off'
        if (bitIndex >= 16) return 'Off';
        
        // Получаем значение бита (0 или 1)
        const bitValue = binaryString[15 - bitIndex]; // Инвертируем для правильного порядка
        
        return bitValue === '1' ? 'On' : 'Off';
    });
}, [stateDi, numberDi]);

    return (
        <div className="DiPch"> 
            <div className="DiPchHeader"> 
                 <h4>Состояние входов Пч</h4>
            </div>
            <div className="DiSignalsPch">
               {numberDi.map((numberDi, index)=>(
                <DiSignal key={numberDi} numberDi={numberDi} onOfDi={diStates[index]} />) )}
            </div>
        </div>
    )
}